<template>
  <div>
    <InputField
      adornment="€"
      :name="`${namePrefix}.fromPrice`"
      :label="
        extraType === VehicleExtraType.EXTRA_KM ? t('fromExtraKmPrice') : t('fromPurchasePrice')
      "
      type="number"
      :min="0"
      :max-fraction-digits="extraType === VehicleExtraType.EXTRA_KM ? 2 : 0"
    />
    <Divider />
    <div class="flex justify-end">
      <CVButton @click="$emit('close')">{{ t('close') }}</CVButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputField from '@/components/InputField.vue';
import Divider from '@/components/Divider.vue';
import { useI18n } from 'vue-i18n';
import type { EditExtraDto } from '@/views/yield-management/edit-extras/EditExtrasView.vue';
import { VehicleExtraType } from '@carvia/ros-client-types';

const props = defineProps<{
  namePrefix: string;
  extraType: EditExtraDto['type'];
}>();

defineEmits<{
  (e: 'close'): void;
}>();

const { t } = useI18n();
</script>

<i18n lang="json">
{
  "en": {
    "fromPurchasePrice": "From vehicle purchase price (Net)",
    "fromExtraKmPrice": "From extra km price"
  },
  "de": {
    "fromPurchasePrice": "Ab Fahrzeug EK (Netto)",
    "fromExtraKmPrice": "Ab Zusatzkilometerpreis"
  },
  "es": {
    "fromPurchasePrice": "Desde precio de compra del vehículo (neto)",
    "fromExtraKmPrice": "Desde precio por km extra"
  }
}
</i18n>
